import React from 'react';
import './show.scss';
import TableUser from './../../../components/Table/TableUser';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';

const ShowUser = () => {
  return (
    <div className='users'>
      <div className="add-button">
        <Link to='/user/addUser'>
          <Button>Créer un utilisateur</Button>
        </Link>
      </div>
      
      <div className='user-table'>
        <TableUser />
      </div>
    </div>
  )
}

export default ShowUser